import ProfileVerificationError from "./ProfileVerificationError"

export default class RequireEmailVerificationError extends ProfileVerificationError {
  constructor(args) {
    super(args)
    this.verificationType = "email"
    this.message = this.message || "Verify your email, please."
  }
}
